import { FormControls } from '@elementary/common-ui/components';
import { statusLabelMap } from '@elementary/common-ui/utils/common';
import { UseFormWatch } from 'react-hook-form';
import { AddTestForm } from 'shared/types';

type Props = {
  watch: UseFormWatch<AddTestForm>;
};

const TablesSchemaChangesAnomaliesConfig = ({ watch }: Props) => (
  <FormControls.FormText>
    Severity: <b>{statusLabelMap[watch('severity')?.type || '']}</b>
  </FormControls.FormText>
);

export default TablesSchemaChangesAnomaliesConfig;
